<h3>Answer as many of these quesitons as you can.</h3>

<!-- <br>
{{questionsAnswersObject | json }}
<br> -->

@if (questionsArray) {
  <mat-grid-list cols="12" rowHeight="50px">
    <!-- <mat-grid-tile
    *ngFor="let question of questionsArray"
    [colspan]=12
    [rowspan]=1>
    {{question}}
  </mat-grid-tile> -->
  <!-- Requested by -->
  <mat-grid-tile
    [colspan]=8
    [rowspan]=1>
    <div class="left-align">
      {{questionsArray[0]}}
    </div>
  </mat-grid-tile>
  <mat-grid-tile
    [colspan]=4
    [rowspan]=1>
    <p-autoComplete class="autocomplete-cell"
      appendTo="body"
      [(ngModel)]="questionsAnswersObject[questionsArray[0]]"
      name="requestor"
      field="friendlyName"
      [suggestions]="filteredUsers"
      (completeMethod)="filterUsers($event)"
      
      [minLength]="1"
      placeholder="User List"
      [dropdown]="true">
      <ng-template let-element pTemplate="item">
        <div style="font-size:22px;font-weight: bold;">
          {{element.friendlyName}}
        </div>
      </ng-template>
    </p-autoComplete>
  </mat-grid-tile>
  <!-- Your phone number -->
  <mat-grid-tile
    [colspan]=8
    [rowspan]=1>
    <div class="left-align">
      {{questionsArray[1]}}
    </div>
  </mat-grid-tile>
  <mat-grid-tile
    [colspan]=4
    [rowspan]=1>
    <input type="tel" matInput placeholder="555-555-1234"
      name="requestorPhoneNumber" maxlength="75"
      [(ngModel)]="questionsAnswersObject[questionsArray[1]]"
      >
  </mat-grid-tile>
  <!-- Your department -->
  <mat-grid-tile
    [colspan]=8
    [rowspan]=1>
    <div class="left-align">
      {{questionsArray[2]}}
    </div>
  </mat-grid-tile>
  <mat-grid-tile
    [colspan]=4
    [rowspan]=1>
    <input matInput
      name="department" maxlength="75"
      [(ngModel)]="questionsAnswersObject[questionsArray[2]]"
      >
  </mat-grid-tile>
  <!-- Executive/Vice President -->
  <mat-grid-tile
    [colspan]=8
    [rowspan]=1>
    <div class="left-align">
      {{questionsArray[3]}}
    </div>
  </mat-grid-tile>
  <mat-grid-tile
    [colspan]=4
    [rowspan]=1>
    <p-autoComplete class="autocomplete-cell"
      appendTo="body"
      [(ngModel)]="questionsAnswersObject[questionsArray[3]]"
      name="executiveSponsor"
      field="friendlyName"
      [suggestions]="filteredUsers"
      (completeMethod)="filterUsers($event)"
      
      [minLength]="1"
      placeholder="User List"
      [dropdown]="true">
      <ng-template let-element pTemplate="item">
        <div style="font-size:22px;font-weight: bold;">
          {{element.friendlyName}}
        </div>
      </ng-template>
    </p-autoComplete>
  </mat-grid-tile>
  <!-- Physicians Name -->
  <mat-grid-tile
    [colspan]=8
    [rowspan]=1>
    <div class="left-align">
      {{questionsArray[4]}}
    </div>
  </mat-grid-tile>
  <mat-grid-tile
    [colspan]=4
    [rowspan]=1>
    <input matInput
      name="physicianName" maxlength="75"
      [(ngModel)]="questionsAnswersObject[questionsArray[4]]"
      >
  </mat-grid-tile>
  <!-- Physicians Notice Information -->
  <mat-grid-tile
    [colspan]=8
    [rowspan]=1>
    <div class="left-align">
      {{questionsArray[5]}}
    </div>
  </mat-grid-tile>
  <mat-grid-tile
    [colspan]=4
    [rowspan]=1>
    <!-- HEADER FOR ADDRESS -->
  </mat-grid-tile>
  <!-- Street Address 1 -->
  <mat-grid-tile
    [colspan]=8
    [rowspan]=1>
    <div class="left-align">
      {{questionsArray[6]}}
    </div>
  </mat-grid-tile>
  <mat-grid-tile
    [colspan]=4
    [rowspan]=1>
    <input matInput
      name="streetAddressOne" maxlength="75"
      [(ngModel)]="questionsAnswersObject[questionsArray[6]]"
      >
  </mat-grid-tile>
  <!-- Street Address 2 -->
  <mat-grid-tile
    [colspan]=8
    [rowspan]=1>
    <div class="left-align">
      {{questionsArray[7]}}
    </div>
  </mat-grid-tile>
  <mat-grid-tile
    [colspan]=4
    [rowspan]=1>
    <input matInput
      name="streetAddressTwo" maxlength="75"
      [(ngModel)]="questionsAnswersObject[questionsArray[7]]"
      >
  </mat-grid-tile>
  <!-- City -->
  <mat-grid-tile
    [colspan]=8
    [rowspan]=1>
    <div class="left-align">
      {{questionsArray[8]}}
    </div>
  </mat-grid-tile>
  <mat-grid-tile
    [colspan]=4
    [rowspan]=1>
    <input matInput
      name="city" maxlength="75"
      [(ngModel)]="questionsAnswersObject[questionsArray[8]]"
      >
  </mat-grid-tile>
  <!-- State -->
  <mat-grid-tile
    [colspan]=8
    [rowspan]=1>
    <div class="left-align">
      {{questionsArray[9]}}
    </div>
  </mat-grid-tile>
  <mat-grid-tile
    [colspan]=4
    [rowspan]=1>
    <input matInput
      name="state" maxlength="2"
      [(ngModel)]="questionsAnswersObject[questionsArray[9]]"
      >
  </mat-grid-tile>
  <!-- Zip -->
  <mat-grid-tile
    [colspan]=8
    [rowspan]=1>
    <div class="left-align">
      {{questionsArray[10]}}
    </div>
  </mat-grid-tile>
  <mat-grid-tile
    [colspan]=4
    [rowspan]=1>
    <input matInput
      name="zip" maxlength="75"
      [(ngModel)]="questionsAnswersObject[questionsArray[10]]"
      >
  </mat-grid-tile>
  <!-- Phone -->
  <mat-grid-tile
    [colspan]=8
    [rowspan]=1>
    <div class="left-align">
      {{questionsArray[12]}}
    </div>
  </mat-grid-tile>
  <mat-grid-tile
    [colspan]=4
    [rowspan]=1>
    <input matInput
      name="phone" maxlength="75"
      [(ngModel)]="questionsAnswersObject[questionsArray[12]]"
      >
  </mat-grid-tile>
  <!-- Physician parent organization name -->
  <mat-grid-tile
    [colspan]=8
    [rowspan]=1>
    <div class="left-align">
      {{questionsArray[13]}}
    </div>
  </mat-grid-tile>
  <mat-grid-tile
    [colspan]=4
    [rowspan]=1>
    <input matInput
      name="physicianParentOrg" maxlength="75"
      [(ngModel)]="questionsAnswersObject[questionsArray[13]]"
      >
  </mat-grid-tile>
  <!-- Legal Entities -->
  <mat-grid-tile
    [colspan]=8
    [rowspan]=1>
    <div class="left-align">
      {{questionsArray[14]}}
    </div>
  </mat-grid-tile>
  <mat-grid-tile
    [colspan]=4
    [rowspan]=1>
    <input matInput
      name="legalEntities" maxlength="75"
      [(ngModel)]="questionsAnswersObject[questionsArray[14]]"
      >
  </mat-grid-tile>
  <!-- Sites -->
  <mat-grid-tile
    [colspan]=8
    [rowspan]=1>
    <div class="left-align">
      {{questionsArray[15]}}
    </div>
  </mat-grid-tile>
  <mat-grid-tile
    [colspan]=4
    [rowspan]=1>
    <input matInput
      name="sites" maxlength="75"
      [(ngModel)]="questionsAnswersObject[questionsArray[15]]"
      >
  </mat-grid-tile>
  <!-- Term -->
  <mat-grid-tile
    [colspan]=8
    [rowspan]=1>
    <div class="left-align">
      {{questionsArray[16]}}
    </div>
  </mat-grid-tile>
  <mat-grid-tile
    [colspan]=4
    [rowspan]=1>
    <input matInput
      name="term" maxlength="10"
      [(ngModel)]="questionsAnswersObject[questionsArray[16]]"
      >
  </mat-grid-tile>
  <!-- Internal or Family -->
  <mat-grid-tile
    [colspan]=8
    [rowspan]=1>
    <div class="left-align">
      {{questionsArray[17]}}
    </div>
  </mat-grid-tile>
  <mat-grid-tile
    [colspan]=4
    [rowspan]=1>
    <input matInput
      name="internalOrFamily" maxlength="75"
      [(ngModel)]="questionsAnswersObject[questionsArray[17]]"
      >
  </mat-grid-tile>
  <!-- Commencement Date -->
  <mat-grid-tile
    [colspan]=8
    [rowspan]=1>
    <div class="left-align">
      {{questionsArray[18]}}
    </div>
  </mat-grid-tile>
  <mat-grid-tile
    [colspan]=4
    [rowspan]=1>
    <input matInput
      name="commencementDate" maxlength="75"
      [(ngModel)]="questionsAnswersObject[questionsArray[18]]"
      >
  </mat-grid-tile>
  <!-- Initial Base -->
  <mat-grid-tile
    [colspan]=8
    [rowspan]=1>
    <div class="left-align">
      {{questionsArray[19]}}
    </div>
  </mat-grid-tile>
  <mat-grid-tile
    [colspan]=4
    [rowspan]=1>
    <input matInput currencyMask
      name="initialBase" maxlength="75"
      [(ngModel)]="questionsAnswersObject[questionsArray[19]]"
      >
  </mat-grid-tile>
  <!-- Signing Bonus -->
  <mat-grid-tile
    [colspan]=8
    [rowspan]=1>
    <div class="left-align">
      {{questionsArray[20]}}
    </div>
  </mat-grid-tile>
  <mat-grid-tile
    [colspan]=4
    [rowspan]=1>
    <input matInput currencyMask
      name="signingBonus" maxlength="75"
      [(ngModel)]="questionsAnswersObject[questionsArray[20]]"
      >
  </mat-grid-tile>
  <!-- Forgivable Loan Amount -->
  <mat-grid-tile
    [colspan]=8
    [rowspan]=1>
    <div class="left-align">
      {{questionsArray[21]}}
    </div>
  </mat-grid-tile>
  <mat-grid-tile
    [colspan]=4
    [rowspan]=1>
    <input matInput currencyMask
      name="forgivableLoanAmount" maxlength="75"
      [(ngModel)]="questionsAnswersObject[questionsArray[21]]"
      >
  </mat-grid-tile>
  <!-- Max comp -->
  <mat-grid-tile
    [colspan]=8
    [rowspan]=1>
    <div class="left-align">
      {{questionsArray[22]}}
    </div>
  </mat-grid-tile>
  <mat-grid-tile
    [colspan]=4
    [rowspan]=1>
    <input matInput currencyMask
      name="maxComp" maxlength="75"
      [(ngModel)]="questionsAnswersObject[questionsArray[22]]"
      >
  </mat-grid-tile>
</mat-grid-list>
}




<button mat-button
  color="primary"
  type="button"
  (click)="onSubmit()">
  Done
</button>

&nbsp;
&nbsp;
&nbsp;

<button mat-button
  color="primary"
  type="button"
  (click)="cancelSubmit()">
  Cancel
</button>